import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectXIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#1F1F1F",
		d: "m7.262 18.948-.707-.708 5.6-5.6-5.6-5.6.707-.708 5.6 5.6 5.6-5.6.708.708-5.6 5.6 5.6 5.6-.708.708-5.6-5.6-5.6 5.6Z"
	})
});
export { SvgSelectXIcon as ReactComponent };
